import React from 'react'
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import { Link } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    color: `${theme.palette.secondary.main} !important`,
    textDecoration: 'none!important',
  },
}))

const PrimaryLink = (props) => {
  const classes = useStyles()
  return (
    <Link
      {...props}
      className={clsx(classes.root, props.className, 'cursor-pointer')}
    >
      {props.children}
    </Link>
  )
}

export default PrimaryLink
